import { isGuestCheckout } from "../../../../lib/buy/is-guest-checkout";

/**
 * Why a card can't be charged, or null. Card is signed-in only (like Orion): a guest has no saved
 * card, and the anonymous create rejects a card body. The quote must also name the saved card.
 */
export function cardUnavailableReason(
  clientToken: string,
  cardId: string | undefined,
): string | null {
  if (isGuestCheckout(clientToken)) {
    return "Card payments require a signed-in customer";
  }
  return cardId ? null : "The quote has no card to charge";
}
